import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import { Button } from 'src/general/components/Button/Button';

interface WholePageMessageProps {
  iconSrc: string;
  title: ReactNode;
  message?: ReactNode;
  buttonLabel: ReactNode;
  buttonLink?: string;
  buttonOnClick?: () => void;
  className?: string;
  fullHeight?: boolean;
}

/**
 * Display a whole-page message to the user, with a button to navigate them away.
 */
export const WholePageMessage: FC<WholePageMessageProps> = ({
  iconSrc,
  title,
  message,
  buttonLabel,
  buttonLink,
  buttonOnClick,
  className,
  fullHeight,
}) => (
  <section
    className={clsx(
      'flex flex-col items-center justify-center gap-6 bg-for-neu-tie2 p-4 text-center',
      { 'min-h-screen': fullHeight, 'min-h-[50vh]': !fullHeight },
      className,
    )}
  >
    <img src={iconSrc} width={180} height={180} alt="" className="size-45 object-contain" />
    <div className="max-w-3xl">
      {typeof title === 'string' ? <h1 className="c-fs-h3 title font-extrabold">{title}</h1> : title}
      {!!message && (typeof message === 'string' ? <p className="c-fs-h6 message">{message}</p> : message)}
    </div>
    <Button href={buttonLink} onClick={buttonOnClick}>
      {buttonLabel}
    </Button>
  </section>
);
